'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _rcDialog = require('rc-dialog');

var _rcDialog2 = _interopRequireDefault(_rcDialog);

var _PopupMixin = require('./PopupMixin');

var _PopupMixin2 = _interopRequireDefault(_PopupMixin);

var _rcTouchable = require('rc-touchable');

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }

var PopupPicker = React.createClass({
  displayName: 'PopupPicker',

  mixins: [_PopupMixin2["default"]],
  getDefaultProps: function getDefaultProps() {
    return {
      prefixCls: 'rmc-picker-popup',
      triggerType: 'onClick',
      WrapComponent: 'span'
    };
  },
  getModal: function getModal() {
    var props = this.props;
    if (!this.state.visible) {
      return null;
    }
    var prefixCls = props.prefixCls;

    return React.createElement(
      _rcDialog2["default"],
      { prefixCls: '' + prefixCls, className: props.className || '', visible: true, closable: false, transitionName: props.transitionName || props.popupTransitionName, maskTransitionName: props.maskTransitionName, onClose: this.hide, style: props.style },
      React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: prefixCls + '-header' },
          React.createElement(
            _rcTouchable2["default"],
            { activeClassName: prefixCls + '-item-active', onPress: this.onDismiss },
            React.createElement(
              'div',
              { className: prefixCls + '-item ' + prefixCls + '-header-left' },
              props.dismissText
            )
          ),
          React.createElement(
            'div',
            { className: prefixCls + '-item ' + prefixCls + '-title' },
            props.title
          ),
          React.createElement(
            _rcTouchable2["default"],
            { activeClassName: prefixCls + '-item-active', onPress: this.onOk },
            React.createElement(
              'div',
              { className: prefixCls + '-item ' + prefixCls + '-header-right' },
              props.okText
            )
          )
        ),
        this.props.content
      )
    );
  },
  render: function render() {
    return this.getRender();
  }
});
exports["default"] = PopupPicker;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rmc-picker/lib/Popup.web.js
 ** module id = 121
 ** module chunks = 0
 **/